export { StatsChart as default } from './StatsChart';
